import { MachineMaintenance } from 'models/MachineMaintenance';

export class WorkshopMaintenance {
    id: number;
    machineId: number;
    machineTypeId: number;
    name: string;
    description: string;
    checked: boolean;

    constructor(
        id: number,
        machineId: number,
        machineTypeId: number,
        name: string,
        description: string,
        checked: boolean,
    ) {
        this.id = id;
        this.machineId = machineId;
        this.machineTypeId = machineTypeId;
        this.name = name;
        this.description = description;
        this.checked = checked;
    }

    static fromMachineMaintenance(mm: MachineMaintenance): WorkshopMaintenance {
        return {
            id: mm.id,
            machineId: mm.machineType.id,
            machineTypeId: mm.machineType.id,
            name: mm.maintenance.name,
            description: mm.maintenance.description,
            checked: false
        };
    }

}